import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'
import UrlBuilder from 'app/utils/UrlBuilder'
import { generateDownloadFileName, downloadFile } from 'app/utils/utils';

const initialState = {    
    expenses : [],
    draftLine : [],
    expenseDraft : [],
    report: null,
    status: HTTP_STATUS.IDLE,
    createStatus: HTTP_STATUS.IDLE,
    removeStatus: HTTP_STATUS.IDLE,
    paymentStatus: HTTP_STATUS.IDLE,
    reportStatus: HTTP_STATUS.IDLE
}


export const fetchExpenseVoucher = createAsyncThunk('expense/get-voucher', async (data, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().searchQuery(data).filter(data, 'fileType').filter(data, 'stDate').filter(data, 'enDate')
        .filter(data, 'cat').filter(data, 'Report_id').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Expense/generate-voucher/${url}`,{ responseType })
        if(responseType === 'text') return response.data
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);       
        return null
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
    
})


export const fetchpendingExpense = createAsyncThunk('expense/get-expenses', async (data = null, { rejectWithValue }) => {
     let url = new UrlBuilder().searchQuery(data).filter(data, 'category').getUrl();
    try {
        const response = await newAxiosInstance.get(BASE_URL + `/api/Expense/${url}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchDraft = createAsyncThunk('expense/get-expenses-draft', async (data = null, { rejectWithValue }) => {
    let url = new UrlBuilder().searchQuery(data).filter(data, 'category').getUrl();
    try {
        const response = await newAxiosInstance.get(BASE_URL + `/api/Expense/get-draft/${url}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const createExpenseV2 = createAsyncThunk('expense/create-expence/v2', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(BASE_URL + '/api/Expense/add-expense', data) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const createExpenseDraft = createAsyncThunk('expense/create-expence-draft', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(BASE_URL + '/api/Expense/draft-expense', data) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const updateExpenditure = createAsyncThunk('expense/update-expense', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.put(BASE_URL + '/api/Expense/'+ data.id, data.body) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const updateDraft = createAsyncThunk('expense/update-expense-draft', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.put(BASE_URL + '/api/Expense/update-draft/'+ data.id, data.body) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const approveDraft = createAsyncThunk('expense/approve-expense-draft', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.put(BASE_URL + '/api/Expense/approve-expense-draft/'+ data.id) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const createPayment = createAsyncThunk('expense/create-payment', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(BASE_URL + '/api/Expense/create-payment', data)
        return response
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const removeExpense = createAsyncThunk('expense/remove-expence', async (id = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.delete(BASE_URL + `/api/Expense/${id}`) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const removeExpenseDraft = createAsyncThunk('expense/remove-expence-draft', async (id = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.delete(BASE_URL + `/api/Expense/remove-draft/${id}`) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const Expense = createSlice({
    name: 'expense',
    initialState,
    reducers: {
        resetState: (state, action) => {
            return initialState;
        },
        resetExpense: (state, action) => {
            state.expenses = []
            return state;
        },
        addDraftLine: (state, action) => {
            state.draftLine = action.payload
            return state
        },
        resetDraftLine: (state, action) => {
            state.draftLine = []
            return state;
        },
        removeDraftLine: (state, action) => {
            let index = state.draftLine.indexOf(action.payload)
            if(index > -1) {
                state.draftLine.splice(index, 1)
            }
            return state;
        },
        updatePaymentStatus: (state, action) => {
            state.paymentStatus = action.payload
        },
        resetExpenseReport: (state, action) => {
            state.report = initialState.report
            state.status = initialState.status
            state.reportStatus = initialState.reportStatus
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchExpenseVoucher.pending, (state, action) => {
                state.reportStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchExpenseVoucher.fulfilled, (state, action) => {
                state.reportStatus = HTTP_STATUS.SUCCEEDED
                state.report = action.payload
            })
            .addCase(fetchExpenseVoucher.rejected, (state, action) => {
                state.reportStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchpendingExpense.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchpendingExpense.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.expenses = action.payload
            })
            .addCase(fetchpendingExpense.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(fetchDraft.fulfilled, (state, action) => {
                state.expenseDraft = action.payload
            })
            .addCase(createExpenseV2.pending, (state, action) => {
                state.createStatus = HTTP_STATUS.LOADING
            })
            .addCase(createExpenseV2.fulfilled, (state, action) => {
                state.createStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(createExpenseV2.rejected, (state, action) => {
                state.createStatus = HTTP_STATUS.FAILED
            })
            .addCase(createExpenseDraft.pending, (state, action) => {
                state.createStatus = HTTP_STATUS.LOADING
            })
            .addCase(createExpenseDraft.fulfilled, (state, action) => {
                state.createStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(createExpenseDraft.rejected, (state, action) => {
                state.createStatus = HTTP_STATUS.FAILED
            })
            .addCase(removeExpense.pending, (state, action) => {
                state.removeStatus = HTTP_STATUS.LOADING
            })
            .addCase(removeExpense.fulfilled, (state, action) => {
                state.removeStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(removeExpense.rejected, (state, action) => {
                state.removeStatus = HTTP_STATUS.FAILED
            })
            .addCase(removeExpenseDraft.pending, (state, action) => {
                state.removeStatus = HTTP_STATUS.LOADING
            })
            .addCase(removeExpenseDraft.fulfilled, (state, action) => {
                state.removeStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(removeExpenseDraft.rejected, (state, action) => {
                state.removeStatus = HTTP_STATUS.FAILED
            })
            .addCase(updateExpenditure.pending, (state, action) => {
                state.createStatus = HTTP_STATUS.LOADING
            })
            .addCase(updateExpenditure.fulfilled, (state, action) => {
                state.createStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(updateExpenditure.rejected, (state, action) => {
                state.createStatus = HTTP_STATUS.FAILED
            })
            .addCase(updateDraft.pending, (state, action) => {
                state.createStatus = HTTP_STATUS.LOADING
            })
            .addCase(updateDraft.fulfilled, (state, action) => {
                state.createStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(updateDraft.rejected, (state, action) => {
                state.createStatus = HTTP_STATUS.FAILED
            })
            .addCase(approveDraft.pending, (state, action) => {
                state.createStatus = HTTP_STATUS.LOADING
            })
            .addCase(approveDraft.fulfilled, (state, action) => {
                state.createStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(approveDraft.rejected, (state, action) => {
                state.createStatus = HTTP_STATUS.FAILED
            })
            .addCase(createPayment.pending, (state, action) => {
                state.paymentStatus = HTTP_STATUS.LOADING
            })
            .addCase(createPayment.fulfilled, (state, action) => {
                state.paymentStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(createPayment.rejected, (state, action) => {
                state.paymentStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getExpenses = (state) => state.expense.expenses;
export const getExpenseDraft = (state) => state.expense.expenseDraft;
export const getExpenseStatus = (state) => state.expense.status;
export const getcreateStatus = (state) => state.expense.createStatus;
export const getPaymentStatus = (state) => state.expense.paymentStatus;
export const getRemoveStatus = (state) => state.expense.removeStatus;
export const getDraftLine = (state) => state.expense.draftLine;
export const getExpenseReport = (state) => state.expense.report;
export const getExpenseReportStatus = (state) => state.expense.reportStatus;

export const expenseAction = Expense.actions

export default Expense.reducer